export const REGEX_INPUT_VALIDATION = '[\x20-\x7E\xa1-\xac\xae-\xff €‚„…‹‘’“”•–—™›œ]+';
